module.exports = ":host .shopping-cart__button--manipulate {\n  display: flex;\n  justify-content: space-between; }\n\n:host .shopping-cart__button--update {\n  margin: 0 0 1.7em; }\n\n:host .shopping-cart__button--delete {\n  margin: 0 0 1.7em; }\n\n:host .shopping-cart__button--next {\n  margin: 1.7em 0 0; }\n\n:host .shopping-cart-event-list__container {\n  border-bottom: 1px solid #c4ceda;\n  border-top: 1px solid #c4ceda;\n  padding: 1em 0 0; }\n\n:host .shopping-cart-comment__container {\n  padding: 1em 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shopping-cart/shopping-cart.scss
// module id = Ys/o
// module chunks = 12